import React from 'react';
import { Link } from 'react-router-dom';
import { I18n } from 'react-redux-i18n';
import styled from 'styled-components';

import Icon from 'components/Icon';
import Button from 'components/Button';

const AllNotationCMSContainer = styled.div<{ hide: boolean }>`
  display: ${(props) => (props.hide ? 'hidden' : 'flex')};
  flex-direction: row;
  align-items: center;
  margin-top: 20px;

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    flex-direction: column;
    justify-content: center;

    .separator {
      display: none;
    }

    .message {
      margin-top: 20px;
      line-height: 24px;
      text-align: center;
    }
  }

  .title {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 20px;
    color: #172c39;
    text-transform: uppercase;
    white-space: nowrap;
    line-height: 24px;
    color: ${(props) => props.theme.colors.dark};
  }

  .titleRed {
    color: ${(props) => props.theme.colors['terra-cotta']};
  }

  .separator {
    height: 60px;
    width: 2px;
    background-color: #adb5bd;
    margin-left: 32px;
    margin-right: 32px;
  }

  p {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    color: #2b3d54;
    width: 70%;
    line-height: 24px;
    font-size: 14px;
  }

  span {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
  }

  .tmpLogoContainer {
    font-size: 90px;
    margin-right: 20px;
  }

  .buttonGoJournals {
    margin-left: 77px;
    width: 261px;
  }
  a {
    text-decoration: none;
  }
`;

// eslint-disable-next-line react/prop-types
const AllNotationCMS = ({ admin = false }: { admin?: boolean }) => (
  <AllNotationCMSContainer hide={false}>
    <div className="tmpLogoContainer">
      <Icon icon="logo-medium" alt="logo-price-cms" />
    </div>
    <div className="separator" />
    <p className="message">{I18n.t('prices.cmsText')}</p>
    {admin && (
      <Link to="/user-space/subscriptions">
        <Button
          label="Gérer mes abonnements"
          textTransform="normal"
          className="buttonGoJournals"
          onClick={undefined}
          icon={undefined}
        />
      </Link>
    )}
  </AllNotationCMSContainer>
);

export default AllNotationCMS;
